export const loadFonts = () => {
  const edenredRegular = new FontFace('Edenred', 'url(/fonts/edenred.woff2)', {
    style: 'normal',
    weight: '400',
  })
  const edenredLight = new FontFace(
    'Edenred',
    'url(/fonts/edenred_light.woff2)',
    {
      style: 'normal',
      weight: '300',
    }
  )
  const edenredLightItalic = new FontFace(
    'Edenred',
    'url(/fonts/edenred_light_italic.woff2)',
    {
      style: 'italic',
      weight: '300',
    }
  )
  const edenredMedium = new FontFace(
    'Edenred',
    'url(/fonts/edenred_medium.woff2)',
    {
      style: 'normal',
      weight: '500',
    }
  )
  const edenredBold = new FontFace(
    'Edenred',
    'url(/fonts/edenred_bold.woff2)',
    {
      style: 'normal',
      weight: '700',
    }
  )
  const edenredBlack = new FontFace(
    'Edenred',
    'url(/fonts/edenred_black.woff2)',
    {
      style: 'normal',
      weight: '900',
    }
  )
  const ubuntu = new FontFace('Ubuntu', 'url(/fonts/ubuntu-regular.woff2)', {
    style: 'normal',
    weight: '400',
  })
  const ubuntuLight = new FontFace('Ubuntu', 'url(/fonts/ubuntu-light.woff2)', {
    style: 'normal',
    weight: '300',
  })
  const ubuntuLightItalic = new FontFace(
    'Ubuntu',
    'url(/fonts/ubuntu-light-italic.woff2)',
    {
      style: 'italic',
      weight: '300',
    }
  )
  const ubuntuBold = new FontFace('Ubuntu', 'url(/fonts/ubuntu-bold.woff2)', {
    style: 'normal',
    weight: '700',
  })
  const ubuntuBoldItalic = new FontFace(
    'Ubuntu',
    'url(/fonts/ubuntu-bold-italic.woff2)',
    {
      style: 'italic',
      weight: '700',
    }
  )
  const ubuntuMedium = new FontFace(
    'Ubuntu',
    'url(/fonts/ubuntu-medium.woff2)',
    {
      style: 'normal',
      weight: '500',
    }
  )
  const ubuntuMediumItalic = new FontFace(
    'Ubuntu',
    'url(/fonts/ubuntu-medium-italic.woff2)',
    {
      style: 'italic',
      weight: '500',
    }
  )

  // This only generates a small glitch (portfolio, set item width)
  // solved by adding <link rel="preload"…
  document.fonts.add(edenredRegular)
  document.fonts.add(edenredLight)
  document.fonts.add(edenredLightItalic)
  document.fonts.add(edenredMedium)
  document.fonts.add(edenredBold)
  document.fonts.add(edenredBlack)
  document.fonts.add(ubuntu)
  document.fonts.add(ubuntuLight)
  document.fonts.add(ubuntuLightItalic)
  document.fonts.add(ubuntuBold)
  document.fonts.add(ubuntuBoldItalic)
  document.fonts.add(ubuntuMedium)
  document.fonts.add(ubuntuMediumItalic)

  return document.fonts.ready
}
